import React, { useEffect, useState, useRef } from 'react';
import CountdownTimer from './CountdownTimer';
import {
  generateOTP,
  validateOTPAndSubmitForm,
  generateRedirectUrlWithUUID,
  getGoldPrice,
  encryptData,
} from '../../lib/otp-function';
import { useLocation, useSearchParams } from 'react-router-dom';
import { RichText, Text, Link, Image } from '@sitecore-jss/sitecore-jss-react';
import { withTranslation } from 'react-i18next';
import { isMobile, isTablet } from 'react-device-detect';
import {
  handleVerifyBtnEvent,
  handleLeadSuccessEvent,
  handleLeadFormOtpCtaClick,
  handleLeadFormCtaClick,
} from '../../lib/customGA4';
import CryptoJS from 'crypto-js';
import { updateGoldResult, updateRupeesResult } from '../../lib/utility-function';
import { Helmet } from 'react-helmet';
import {
  amountTransform,
  calculateSipEMI,
  lumpSumCalculation,
} from '../../lib/MFProductCalculation';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { fetchPlanId } from '../../lib/MFIdUtil';
import { getLumsumCalculatorData, getSIPCalculatorData } from '../../lib/ApiServiceMF';

const ABCDLeadForm = (props) => {
  const queryParams = useLocation().search;
  const params = new URLSearchParams(queryParams);

  const [redirecting, setRedirecting] = useState(false);
  const [countdown, setCountdown] = useState(props.rendering?.fields?.RedirectTimer?.value || 0); // Countdown duration in seconds
  const timeoutRef = useRef();

  let buttonText = props?.i18n?.store?.data?.en?.translation || {};

  const [agreed, setAgreed] = useState(true);
  const [name, setName] = useState('');
  const [mobileNumber, setMobileNumber] = useState('');
  const [isVerified, setIsVerified] = useState(false);
  const [isMobileNumerVerified, setIsMobileNumerVerified] = useState(false);
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [phoneErrorVisible, setPhoneErrorVisible] = useState(false);
  const [otpSent, setOtpSent] = useState(false);
  const [otpValidationFailed, setOtpValidationFailed] = useState(false);
  const [otpSuccess, setOtpSuccess] = useState(false);
  const [otpMessage, setOtpMessage] = useState('');
  const [otpValue, setOtpValue] = useState(['', '', '', '', '', '']);
  const [active, setActive] = useState(null);
  const [dropDownKey, selectDropDownKey] = useState(null);
  const [isDropdownVisible, setDropdownVisible] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [email, setEmail] = useState('');
  const [currentStep, setCurrentStep] = useState(1);
  const [formClasses, setFormClasses] = useState({
    form1: 'form-active',
    form2: '',
    form3: '',
  });
  const [responseCode, setResponseCode] = useState();
  const [dropDownValues, setDropDownValues] = useState();
  const [productCTA, setProductCTA] = useState();
  const [product_SimpleRedirection, setproduct_SimpleRedirection] = useState();
  const [submittingForm, setSubmittingForm] = useState(false);

  const [dropdownProductCode, setDropdownProductCode] = useState();
  const [dropdownRedirectProductURL, setDropdownRedirectProductURL] = useState();
  const [dropdownRedirectURL, setDropdownRedirectURL] = useState();

  // gold loan
  const [activeLoanType, setActiveLoanType] = useState('Fresh');
  const [loanAmount, setLoanAmount] = useState('');
  const [pincode, setPincode] = useState('');
  const pincodeRef = useRef(pincode);
  const loanAmountRef = useRef(loanAmount);

  const lob = props?.fields?.LOB?.fields?.Key?.value;
  const productName = props?.fields?.ProductName?.fields?.Key?.value;
  const formType = props?.fields?.FormType?.fields?.Key?.value;

  const queryparameters = {
    UtmADGroup: params.get('UtmADGroup') || '',
    UtmADID: params.get('UtmADID') || '',
    UtmCampaign: params.get('UtmCampaign') || '',
    UtmContent: params.get('UtmContent') || '',
    UtmId: params.get('UtmId') || '',
    UtmMedium: params.get('UtmMedium') || '',
    UtmSource: params.get('UtmSource') || '',
    UtmTerm: params.get('UtmTerm') || '',
  };
  const apiParameters = {
    Source: props?.fields?.Source?.fields?.Key?.value || '',
    SubSource: props?.fields?.SubSource?.fields?.Key?.value || '',
    CurrentSubSource: props?.fields?.CurrentSubSource?.value || '',
    LOB:
      props?.fields?.ProductDropdown?.length <= 0
        ? props?.fields?.LOB?.fields?.Key?.value
        : dropDownValues?.lob?.value || '',
    TypeOfBusiness: props?.fields?.TypeOfBusiness?.fields?.Key?.value || '',
    ProductCategory:
      props?.fields?.ProductDropdown?.length <= 0
        ? props?.fields?.ProductCategory?.fields?.Key?.value
        : dropDownValues?.product_category?.value || '',
    ProductName:
      props?.fields?.ProductDropdown?.length <= 0
        ? props?.fields?.ProductName?.fields?.Key?.value
        : dropDownValues?.product_name?.value || '',
    FormType: props?.fields?.FormType?.fields?.Key?.value || '',
    DeviceType: isMobile ? 'Mobile' : 'Desktop',
  };

  const dropdownRef = useRef(null);
  const countdownTimerRef = useRef();

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setDropdownVisible(false); // Hide the dropdown
    }
  };

  useEffect(() => {
    // Add event listener to detect clicks outside dropdown
    if (typeof document !== 'undefined') {
      document.addEventListener('click', handleClickOutside);
    }

    // Cleanup event listener on component unmount
    return () => {
      if (typeof document !== 'undefined') {
        document.removeEventListener('click', handleClickOutside);
      }
    };
  }, []);

  useEffect(() => {
    if (ProductDropdown?.length > 0) {
      setSelectedCategory(ProductDropdown[0]?.fields?.Label?.value);
    }
  }, []);

  const [selectedImage, setSelectedImage] = useState('https://abconeprod.azureedge.net/dist/ABCD/assets/images/select_category.svg');
  const toggleDropdown = () => {
    setDropdownVisible(!isDropdownVisible);
  };

  const handleCategorySelect = (category) => {
    const selectedImageNew = category.icon || 'https://abconeprod.azureedge.net/dist/ABCD/assets/images/category/select_category.svg';

    setSelectedCategory(category.name.value);
    selectDropDownKey(category.Key.value);
    setSelectedImage(selectedImageNew);
    setActive(category.name.value);
    setDropdownVisible(false);
    updateVerificationStatus();
    setDropDownValues(category);
    setProductCTA(category?.product_cta?.value?.href);
    setproduct_SimpleRedirection(category?.product_SimpleRedirection?.value);
    setDropdownProductCode(category?.redirect_product_code?.value);
    setDropdownRedirectProductURL(category?.redirect_product_url?.value?.href);
    setDropdownRedirectURL(category?.redirect_url?.value?.href);
  };

  const ProductDropdown = props?.rendering?.fields?.ProductDropdown || [];
  const handleNameChange = (e) => {
    const enteredValue = e.target.value;

    const isValidName = /^[A-Za-z\s]{0,50}$/.test(enteredValue);

    if (isValidName) {
      setName(enteredValue);
    }

    updateVerificationStatus();
  };

  const handleKeyPress = (event) => {
    const isValidInput =
      /^[\d\s()-]*$/.test(event.key) || event.key === 'Backspace' || event.key === 'Delete';

    if (!isValidInput) {
      event.preventDefault();
    }

    if ((event.key === 'Backspace' || event.key === 'Delete') && !event.target.value) {
      event.preventDefault();
    }
  };

  const handleMobileNumberChange = (e) => {
    const enteredValue = e.target.value;

    const isValidMobileNumber =
      /^[6-9][0-9]{0,9}$/.test(enteredValue.replace(/\D/g, '')) && !/(.)\1{6,}/.test(enteredValue);

    if (isValidMobileNumber || enteredValue === '') {
      setMobileNumber(enteredValue.replace(/\D/g, ''));
      setPhoneErrorVisible(false);
      setIsMobileNumerVerified(true);
      updateVerificationStatus();
    } else {
      setPhoneErrorVisible(true);
      setIsMobileNumerVerified(false);
    }
  };

  const updateVerificationStatus = () => {
    let isValid =
      name.trim() !== '' &&
      mobileNumber.trim() !== '' &&
      mobileNumber.length === 10 &&
      (formSubmitted ? isMobileNumerVerified : true) &&
      agreed &&
      (!selectedCategory ||
        (ProductDropdown.length > 0 &&
          ProductDropdown[0]?.fields?.Label?.value !== selectedCategory));

    // Additional checks for gold loan fields
    if (props?.params?.IsGoldLoan === '1') {
      isValid =
        isValid &&
        pincodeRef.current.trim() !== '' &&
        pincodeRef.current.length === 6 && // Assuming pincode should be exactly 6 digits
        loanAmountRef.current.trim() !== '' &&
        loanAmountRef.current.trim() > 30000 &&
        !isNaN(loanAmountRef.current) && // Ensure loanamount is a number
        activeLoanType.trim() !== ''; // Ensure loantype is selected
    }
    setIsVerified(isValid);
  };

  useEffect(() => {
    updateVerificationStatus();

    setFormClasses((prevClasses) => ({
      ...prevClasses,
      [`form${currentStep}`]: 'form-active',
    }));

    setTimeout(() => {
      setFormClasses((prevClasses) => ({
        ...prevClasses,
        [`form${currentStep - 1}`]: '',
      }));
    }, 1000);
  }, [currentStep, selectedCategory, mobileNumber, name, agreed]);

  const gotoNextForm = (stepPrev, stepNext) => {
    setCurrentStep(stepNext);
  };

  const inputs = useRef([]);

  const handleSubmit = (e) => {
    e.preventDefault();
    setFormSubmitted(true);

    if (!/^\d{10}$/.test(mobileNumber)) {
      setPhoneErrorVisible(true);
      return;
    }

    handleLeadFormOtpCtaClick(
      props?.fields?.GetOtpButton?.value
        ? props?.fields?.GetOtpButton?.value
        : props.t('OTPButton'),
      null,
      selectedCategory,
      'right_first_fold'
    );

    generateOTP(mobileNumber, setOtpMessage, setOtpSent, setOtpSuccess);

    gotoNextForm(1, 2);
  };

  const handleChange = (index, value) => {
    if (isNaN(value)) return;

    const updatedOtpValue = [...otpValue];
    updatedOtpValue[index] = value;

    setOtpValue(updatedOtpValue);

    if (value !== '' && index < 5) {
      inputs.current[index + 1].focus();
    }
  };

  const resendCode = () => {
    handleLeadFormCtaClick(buttonText.ResendOtp, null, selectedCategory, 'right_first_fold');
    countdownTimerRef.current.reset();
    setOtpValue(['', '', '', '', '', '']);

    generateOTP(mobileNumber, setOtpMessage, setOtpSent, setOtpSuccess);
    setResponseCode();
  };

  const changeNumber = () => {
    handleLeadFormCtaClick(props.t('ChangeNumber'), null, selectedCategory, 'right_first_fold');
    gotoNextForm(2, 1);
    setOtpValue(['', '', '', '', '', '']);
    setResponseCode();
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const pasteData = e.clipboardData.getData('text/plain').slice(0, 6);

    for (let i = 0; i < pasteData.length; i++) {
      handleChange(i, pasteData[i]);
    }
  };

  const isOtpFilled = () => {
    return otpValue.every((value) => value !== '');
  };

  const handleKeyDown = (index, e) => {
    if (e.key === 'Backspace' && index > 0 && otpValue[index] === '') {
      inputs.current[index - 1].focus();
    }
  };

  const validateAndSubmit = async (e, buttonText) => {
    e.preventDefault();
    if (submittingForm) {
      return;
    }
    setSubmittingForm(true);
    const otp = otpValue.join('');
    var vem_assignment_check = props.rendering?.fields?.RedirectURL?.value?.url
      ? false
      : props.rendering?.fields?.VEMAssigmentFalse?.value === false
      ? true
      : false;

    const formData = {
      otp: otp,
      mobileNumber: mobileNumber,
      name: name,
      email: email,
      agreed: agreed,
      apiParameters: apiParameters,
      queryparameters: queryparameters,
      pageUrl: window.location.href,
      vem_assignment_check: vem_assignment_check,
      loanAmount,
      loanType: activeLoanType,
      pincode,
    };

    const encryptedFormData = encryptData(
      JSON.stringify(formData),
      props?.t('SecretKey'),
      props?.t('SecretKeyIV')
    );
    const formSubmitResponse = await validateOTPAndSubmitForm(encryptedFormData);

    setResponseCode(formSubmitResponse?.ReturnCode);
    setSubmittingForm(false);

    if (
      formSubmitResponse?.compositeResponse[0]?.httpStatusCode === 200 ||
      formSubmitResponse?.compositeResponse[0]?.httpStatusCode === 201 ||
      formSubmitResponse?.compositeResponse[0]?.httpStatusCode === 400
    ) {
      handleVerifyBtnEvent(buttonText, null, selectedCategory, 'right_first_fold');
      handleLeadSuccessEvent(
        buttonText,
        null,
        selectedCategory,
        'right_first_fold',
        formSubmitResponse?.compositeResponse[0].body?.id
      );
      setOtpSent(true);
      setOtpValidationFailed(false); // Reset the validation error when OTP is valid
      // Check if the URL is provided and redirect
      const redirectUrl = props.rendering?.fields?.RedirectURL?.value?.url;
      const simpleRedirection = props.rendering?.fields?.SimpleRedirection?.value;

      const leadId = formSubmitResponse?.compositeResponse[0]?.body[0]?.message
        ?.split(':')[1]
        ?.trim();

      const successLeadId = formSubmitResponse?.compositeResponse[0].body?.id;

      const source = window.location.href.split('/').filter(Boolean).pop();
      const channel = 'web';
      const url = window?.location?.href;

      if (dropdownRedirectProductURL && !product_SimpleRedirection) {
        generateRedirectUrl(
          dropdownRedirectURL ?? redirectUrl,
          successLeadId ? successLeadId : leadId,
          product_SimpleRedirection,
          dropdownProductCode,
          dropdownRedirectProductURL,
          source,
          channel,
          url
        );
      } else if (dropdownRedirectURL && !product_SimpleRedirection) {
        generateRedirectUrl(
          dropdownRedirectURL ?? redirectUrl,
          successLeadId ? successLeadId : leadId,
          product_SimpleRedirection,
          dropdownProductCode,
          new URL(dropdownRedirectURL).origin ?? new URL(redirectUrl).origin,
          source,
          channel,
          url
        );
      } else if (productCTA && !product_SimpleRedirection) {
        window.location.href = productCTA;
      } else if (props?.rendering?.fields?.RedirectProductURL?.value?.url && !simpleRedirection) {
        generateRedirectUrl(
          redirectUrl,
          successLeadId ? successLeadId : leadId,
          simpleRedirection,
          props?.rendering?.fields?.RedirectProductCode?.value,
          props?.rendering?.fields?.RedirectProductURL?.value?.url,
          source,
          channel,
          url
        );
      } else if (props.rendering?.fields?.RedirectProductURL?.value?.url && simpleRedirection) {
        window.location.href = props.rendering?.fields?.RedirectProductURL?.value?.url;
      } else if (redirectUrl && !simpleRedirection) {
        generateRedirectUrl(
          redirectUrl,
          successLeadId ? successLeadId : leadId,
          simpleRedirection,
          props.rendering?.fields?.RedirectProductCode?.value,
          new URL(redirectUrl).origin,
          source,
          channel,
          url
        ); // Handle redirect in a separate function
      } else if (redirectUrl && simpleRedirection) {
        window.location.href = props.rendering?.fields?.RedirectURL?.value?.url;
      } else {
        gotoNextForm(2, 3); // Proceed to the next form step if no URL is provided
      }
    } else if (formSubmitResponse?.ReturnCode === '-1') {
      setResponseCode(formSubmitResponse?.ReturnCode);
      setOtpValidationFailed(true);
    } else if (formSubmitResponse?.ReturnCode === '0') {
      setResponseCode(formSubmitResponse?.ReturnCode);
    } else {
      setOtpSent(false);
      setOtpValidationFailed(true);
    }
  };

  const groupedItems = ProductDropdown.slice(1).reduce((acc, currentItem) => {
    const { fields } = currentItem;
    const { GroupNumber } = fields;
    const { value } = GroupNumber;

    if (!acc[value]) {
      acc[value] = [];
    }

    acc[value].push(currentItem);

    return acc;
  }, {});

  const handleOnSubmit = handleSubmit;

  useEffect(() => {
    if (!props.rendering?.fields?.RedirectURL?.value?.url) return;

    if (redirecting && countdown > 0) {
      timeoutRef.current = setTimeout(() => {
        setCountdown((prevCount) => prevCount - 1);
      }, 1000);

      return () => clearTimeout(timeoutRef.current);
    } else if (redirecting && countdown === 0) {
      const url = generateRedirectUrl();
      handleRedirect(url);
    }
  }, [redirecting, countdown, props.rendering]);

  const handleStay = () => {
    setRedirecting(false);
    clearTimeout(timeoutRef.current);
  };

  const generateRedirectUrl = async (
    url,
    id,
    simpleRedirection,
    productCode,
    redirectURL,
    source,
    channel,
    pageurl
  ) => {
    try {
      if (simpleRedirection !== true) {
        const dynamicObject = {
          mobileNumber: encodeURIComponent(mobileNumber),
          username: encodeURIComponent(name),
          productId: encodeURIComponent(productCode),
          lmsId: encodeURIComponent(id),
          source,
          channel,
          url: pageurl,
        };

        const encryptedObject = encryptData(
          JSON.stringify(dynamicObject),
          props?.t('SecretKey'),
          props?.t('SecretKeyIV')
        );
        const response = await generateRedirectUrlWithUUID(
          url,
          mobileNumber,
          encryptedObject,
          source,
          channel
        );
        if (response) {
          window.location.href = `${new URL(redirectURL)}?${props.t('query_param_uuid')}=${
            response?.uuid
          }`;
        }
      } else {
        window.location.href = url;
      }
    } catch (error) {
      console.error('Error generating redirect URL with UUID:', error);
    }
  };
  const handleRedirect = async (url) => {
    const dynamicObject = {
      mobileNumber: encodeURIComponent(mobileNumber),
      username: encodeURIComponent(name),
      productId: encodeURIComponent(props.rendering?.fields?.RedirectProductCode?.value),
      lmsId: encodeURIComponent(id),
    };
    const encryptedMobileNumber = encryptData(
      mobileNumber,
      props?.t('SecretKey'),
      props?.t('SecretKeyIV')
    );
    const encryptedObject = encryptData(
      JSON.stringify(dynamicObject),
      props?.t('SecretKey'),
      props?.t('SecretKeyIV')
    );
    try {
      const response = await generateRedirectUrlWithUUID(url, mobileNumber, encryptedObject);
      if (response) {
        window.location.href = `${
          props.rendering?.fields?.RedirectProductURL?.value?.url
            ? props.rendering.fields.RedirectProductURL.value.url
            : new URL(url).origin
        }?${props.t('query_param_uuid')}=${response?.uuid}`;
      }
    } catch (error) {
      console.error('Error generating redirect URL with UUID:', error);
    }
  };

  useEffect(() => {
    if (currentStep === 3) {
      setRedirecting(true);
    }
  }, [currentStep]);

  // start digigold section

  const radioButtons = props?.fields?.RadioButtons || [];
  const [selectedRadio, setSelectedRadio] = useState(radioButtons[0]?.name || '');
  const [selectedCheckbox, setSelectedCheckbox] = useState(
    radioButtons[0]?.fields?.Contents[0]?.fields?.Title?.value || ''
  );

  const [gramValueReuslt, setGramValueResult] = useState();
  const [rupeeValueResult, setRupeeValueResult] = useState();

  const [quote, setQuote] = useState();

  const [amount, setAmount] = useState();

  const handleRadioChange = (event) => {
    const selectedRadioName = event.target.value;
    setSelectedRadio(selectedRadioName);

    // Reset checkbox selection to the first item of the newly selected radio button group
    const defaultCheckbox = radioButtons.find((button) => button.name === selectedRadioName)?.fields
      .Contents[0]?.fields?.Title?.value;
    setSelectedCheckbox(defaultCheckbox);
  };

  const handleCheckboxChange = (title) => {
    setSelectedCheckbox(title);

    if (selectedRadio === 'BuyInRupee') {
      setAmount(selectedCheckbox?.replace(/,/g, ''));

      var goldResult = updateGoldResult(
        parseFloat(amount).toFixed(2),
        parseFloat(quote?.preTaxAmount).toFixed(2)
      );
      setGramValueResult(goldResult);
      setRupeeValueResult();
    }

    if (selectedRadio === 'BuyInGrams') {
      setAmount(selectedCheckbox);

      var rupeeResult = updateRupeesResult(
        parseFloat(amount).toFixed(2),
        parseFloat(quote?.preTaxAmount).toFixed(2)
      );

      setRupeeValueResult(rupeeResult);
      setGramValueResult();
    }
  };

  useEffect(() => {
    if (selectedRadio === 'BuyInRupee') {
      setAmount(selectedCheckbox?.replace(/,/g, ''));
    }
    if (selectedRadio === 'BuyInGrams') {
      setAmount(selectedCheckbox?.trim());
    }
  }, [selectedCheckbox, selectedRadio]);

  useEffect(() => {
    if (selectedRadio === 'BuyInRupee') {
      var goldResult = updateGoldResult(
        parseFloat(amount).toFixed(2),
        parseFloat(quote?.preTaxAmount).toFixed(2)
      );
      setGramValueResult(goldResult);
      setRupeeValueResult();
    }
    if (selectedRadio === 'BuyInGrams') {
      var rupeeResult = updateRupeesResult(
        parseFloat(amount).toFixed(2),
        parseFloat(quote?.preTaxAmount).toFixed(2)
      );
      setRupeeValueResult(rupeeResult);
      setGramValueResult();
    }
  }, [selectedCheckbox, selectedRadio, amount, quote]);

  const apiData = async () => {
    setQuote(await getGoldPrice());
  };

  useEffect(() => {
    const fetchData = async () => {
      await apiData();
    };
    fetchData();
  }, []);

  const handleAmountChange = (e) => {
    let enteredAmount = e.target.value;

    const isValidNumber = /^[0-9]*\.?[0-9]*$/.test(enteredAmount);

    if (isValidNumber && !isNaN(enteredAmount)) {
      enteredAmount = parseFloat(enteredAmount);
      if (enteredAmount > 9999999) {
        setAmount(9999999);
      } else {
        setAmount(enteredAmount);
      }
    }

    updateVerificationStatus();
    setSelectedCheckbox();
  };

  // end digigold section

  // start mf product section
  const [activeOption, setActiveOption] = useState('SIP');
  const [planId, setPlanId] = useState(null);
  const [sipCalculatorData, setSipCalculatorData] = useState({});
  const [lumsumCalculatorData, setLumsumCalculatorData] = useState({});
  const [selectedCalculatorData, setSelectedCalculatorData] = useState({});
  const [investmentAmount, setInvestmentAmount] = useState('');

  const handleToggleClick = (option) => {
    setActiveOption(option);
    if (option === 'SIP') {
      setSelectedCalculatorData(sipCalculatorData);
    } else if (option === 'Lump-sum') {
      setSelectedCalculatorData(lumsumCalculatorData);
    }
  };

  useEffect(() => {
    const fetchPlan = async () => {
      const id = await fetchPlanId();
      setPlanId(id);
    };

    fetchPlan();
  }, []);

  const validationSchema = Yup.object().shape({
    investedAmount: Yup.number()
      .min(
        props?.fields?.MinInvestAmount?.value,
        `Minimum value is ${props?.fields?.MinInvestAmount?.value}`
      )
      .max(
        props?.fields?.MaxInvestAmount?.value,
        `Maximum value is ${props?.fields?.MaxInvestAmount?.value}`
      ),
    targetedReturnValue: Yup.number()
      .min(
        props?.fields?.MinTargetedReturnValue?.value,
        `Minimum value is ${props?.fields?.MinTargetedReturnValue?.value}`
      )
      .max(
        props?.fields?.MaxTargetedReturnValue?.value,
        `Maximum value is ${props?.fields?.MaxTargetedReturnValue?.value}`
      ),
  });

  const formik = useFormik({
    initialValues: {
      investedAmount: props?.fields?.MinInvestAmount?.value,
      targetedReturnValue: props?.fields?.MinTargetedReturnValue?.value,
    },
    validationSchema,
    validateOnChange: true,
  });

  const periodLabels = {
    r1year: '1 Year',
    r3year: '3 Years',
    r5year: '5 Years',
    r6month: '6 mos',
  };

  const [selectedPeriod, setSelectedPeriod] = useState({
    key: 'r6month',
    label: periodLabels?.r6month,
    labelValue: 0.5,
    sipValue: parseFloat(sipCalculatorData.r6month ?? 0).toFixed(6),
    returnValue: parseFloat(lumsumCalculatorData.ret_6month ?? 0).toFixed(6),
  });

  useEffect(() => {
    const fetchData = async () => {
      if (planId) {
        setSipCalculatorData(await getSIPCalculatorData(planId));
        setLumsumCalculatorData(await getLumsumCalculatorData(planId));
      }
    };

    fetchData();
  }, [planId]);

  const combinedData = [
    {
      key: 'r6month',
      label: periodLabels.r6month,
      labelValue: 0.5,
      sipValue: parseFloat(sipCalculatorData.r6month ?? 0).toFixed(6),
      returnValue: parseFloat(lumsumCalculatorData.ret_6month ?? 0).toFixed(6),
    },
    {
      key: 'r1year',
      label: periodLabels.r1year,
      labelValue: 1,
      sipValue: parseFloat(sipCalculatorData.r1year ?? 0).toFixed(6),
      returnValue: parseFloat(lumsumCalculatorData.ret_1year ?? 0).toFixed(6),
    },
    {
      key: 'r3year',
      label: periodLabels.r3year,
      labelValue: 3,
      sipValue: parseFloat(sipCalculatorData.r3year ?? 0).toFixed(6),
      returnValue: parseFloat(lumsumCalculatorData.ret_3year ?? 0).toFixed(6),
    },
    {
      key: 'r5year',
      label: periodLabels.r5year,
      labelValue: 5,
      sipValue: parseFloat(sipCalculatorData.r5year ?? 0).toFixed(6),
      returnValue: parseFloat(lumsumCalculatorData.ret_5year ?? 0).toFixed(6),
    },
  ];

  const [calculatedEmi, changeCalculatedEmi] = useState(0);
  const [totalInvested, changeTotalInvested] = useState(0);
  const [totalGain, changeTotalGain] = useState(0);

  const [requiredInvestment, setRequiredInvestment] = useState(0);
  const [expectedWealthGain, setExpectedWealthGain] = useState(0);

  const handleCalculatorPeriodChange = (key) => {
    const period = combinedData.find((item) => item.key === key);
    setSelectedPeriod(period);
  };

  useEffect(() => {
    if (activeOption === 'SIP') {
      var result = calculateSipEMI(
        investmentAmount,
        selectedPeriod.labelValue,
        parseFloat(selectedPeriod.sipValue).toFixed(6)
      );
      setRequiredInvestment(0);
      setExpectedWealthGain(0);

      changeCalculatedEmi(result || 0);
      var totalInvested = Math.round(result * parseFloat(selectedPeriod.labelValue) * 12);
      changeTotalInvested(totalInvested || 0);
      var totalGain =
        investmentAmount - Math.round(result * parseFloat(selectedPeriod.labelValue) * 12);
      changeTotalGain(totalGain || 0);
    } else if (activeOption === 'Lump-sum') {
      var { a, o } = lumpSumCalculation(
        investmentAmount,
        selectedPeriod.labelValue,
        parseFloat(selectedPeriod.returnValue).toFixed(6)
      );
      changeTotalInvested(0);
      changeTotalGain(0);

      setRequiredInvestment(amountTransform(Math.round(o), false) || 0);
      setExpectedWealthGain(amountTransform(Math.round(a), false) || 0);
    }
  }, [selectedPeriod, activeOption, investmentAmount]);

  // end mf product section

  // gold loan starts

  const handlePincodeChange = (e) => {
    let inputValue = e.target.value.replace(/\D/g, '').trim();
    setPincode(inputValue);
    pincodeRef.current = inputValue;
    updateVerificationStatus();
  };

  const handleloanAmountChange = (e) => {
    let inputValue = e.target.value.replace(/\D/g, '').trim();
    setLoanAmount(inputValue);
    loanAmountRef.current = inputValue;
    updateVerificationStatus();
  };

  // gold loan end

  return (
    <>
      {props?.params?.IsDigiGold === '1' && (
        <Helmet>
          <link rel="stylesheet" type="text/css" href="https://abconeprod.azureedge.net/dist/ABCD/assets/css/products_page.css" media="all" />
          <link rel="stylesheet" type="text/css" href="https://abconeprod.azureedge.net/dist/ABCD/assets/css/digi-gold.css" media="all" />
          <link
            rel="stylesheet"
            type="text/css"
            href="https://abconeprod.azureedge.net/dist/ABCD/assets/css/categorypage-style-2.css"
            media="all"
          />
        </Helmet>
      )}
      <div className="start_journey_form_wrapper">
        <div className="to-help-form-area">
          <div className="to-help-div">
            <div className="to-help-stepper-form-mb">
              <div className="stepper">
                <div className="step--1 step-active">Step 1</div>
                <div className="step--2">Step 2</div>
                <div className="step--3">Step 3</div>
                <div className="step--4">Finish</div>
              </div>
              <div className="form-parent form-parent_wrap">
                {}
                {currentStep === 1 && (
                  <form
                    className={`form ${formClasses.form1}`}
                    id="stepper-form-1-step-1"
                    onSubmit={handleOnSubmit}
                  >
                    <div className="start_journey_head_Wrapper left_heading_wrap">
                      <RichText
                        className="jounrneyStepHeading"
                        field={props.rendering.fields.Heading || ''}
                        editable
                      />
                      <p>
                        <Text field={props.rendering.fields.SubHeading || ''} editable />
                      </p>
                    </div>
                    {/* digigold section start here */}

                    {props?.params?.IsDigiGold === '1' && (
                      <>
                        <div className="current_gold_rate">
                          <span>
                            <em className="circle pulse orange" />
                            {props.t('CURRENT_PRICE')}
                          </span>
                          <p>
                            {props?.t('CURRENCY_ICON')}{' '}
                            {parseFloat(quote?.preTaxAmount ? quote?.preTaxAmount : 0).toFixed(2)}/
                            {props?.t('WEIGHT_GM')}
                          </p>
                        </div>
                        <ul className="calc_tab_radio_Wrapper">
                          {radioButtons.map((radio) => (
                            <li key={radio.id} className="nav-item" role="presentation">
                              <label
                                className={`nav-link ${
                                  selectedRadio === radio.name ? 'active' : ''
                                }`}
                                id={`pills-radio-${radio.name}-tab`}
                                type="button"
                                role="tab"
                                aria-controls={`pills-radio-${radio.name}`}
                                aria-selected={selectedRadio === radio.name}
                              >
                                <input
                                  type="radio"
                                  name="radio7"
                                  value={radio.name}
                                  checked={selectedRadio === radio.name}
                                  onChange={handleRadioChange}
                                />
                                <span>{radio.fields.heading.value}</span>
                              </label>
                            </li>
                          ))}
                        </ul>
                      </>
                    )}

                    {/* digigold section end  here */}
                    <div className="form-input-main top-overlap">
                      <input type="hidden" id="lob" value={lob} />
                      <input type="hidden" id="formType" value={formType} />
                      {/* mf product start */}
                      {props?.params?.IsMFProduct && (
                        <div className="toggleOptWrapper">
                          <ul className="toggleOpt">
                            <li
                              className={activeOption === 'SIP' ? 'active' : ''}
                              onClick={() => handleToggleClick('SIP')}
                            >
                              {props?.t('SIP')}
                            </li>
                            <li
                              className={activeOption === 'Lump-sum' ? 'active' : ''}
                              onClick={() => handleToggleClick('Lump-sum')}
                            >
                              {props?.t('Lump-sum')}
                            </li>
                          </ul>
                        </div>
                      )}

                      {/* mf product end */}

                      {ProductDropdown.length > 0 && (
                        <div className="input-field fieldset select-set">
                          <div
                            ref={dropdownRef}
                            className={`dropdown ${
                              isDropdownVisible ? 'dropdown__options--visible' : ''
                            }`}
                          >
                            <div className="dropdown__skeleton" onClick={toggleDropdown}>
                              <div className="dropdown__selected dropdown__option">
                                <div className="inpt-icon">
                                  <img
                                    className="input-img"
                                    src={selectedImage}
                                    alt="dropdown"
                                    loading="lazy"
                                  />
                                </div>
                                <span onChange={() => setDropdown(selectedCategory)}>
                                  {selectedCategory}
                                </span>
                              </div>

                              <div className="dropdown__arrow"></div>
                            </div>

                            <div className="dropdown__options">
                              {Object.keys(groupedItems).map((category, index) => (
                                // <div key={index} className="dropdown__option_set_Wrapper">
                                <div key={index}>
                                  {groupedItems[category].map((item, itemIndex) => (
                                    <div
                                      key={itemIndex}
                                      className={`dropdown__option ${
                                        selectedCategory === item.fields?.Label.value
                                          ? 'active'
                                          : ''
                                      }`}
                                      onClick={() =>
                                        handleCategorySelect({
                                          name: item.fields?.Label,
                                          Key: item.fields?.Key,
                                          icon:
                                            item.fields?.Icon?.value?.src || 'default-image-url',
                                          lob: item.fields?.LOB,
                                          product_name: item.fields?.ProductName,
                                          product_category: item?.fields?.ProductCategory,
                                          product_cta: item?.fields?.CTALink,
                                          product_SimpleRedirection:
                                            item?.fields?.SimpleRedirection,
                                          redirect_product_code: item?.fields?.RedirectProductCode,
                                          redirect_product_url: item?.fields?.RedirectProductURL,
                                          redirect_url: item?.fields?.RedirectURL,
                                        })
                                      }
                                    >
                                      <div className="inpt-icon2">
                                        <img
                                          className="input-img"
                                          style={{ width: '15px' }}
                                          src={item.fields?.Icon?.value?.src || 'default-image-url'}
                                          alt="img"
                                          loading="lazy"
                                          onError={(e) => console.error('Image failed to load:', e)}
                                        />
                                      </div>
                                      <span>
                                        <div>
                                          <RichText field={item.fields?.Label} editable />
                                        </div>
                                      </span>
                                    </div>
                                  ))}
                                </div>
                                // </div>
                              ))}
                            </div>
                          </div>
                        </div>
                      )}

                      <div className="input-field fieldset name-field">
                        <div className="input-inner">
                          <div className="inpt-icon">
                            <img
                              className="input-img"
                              src="https://abconeprod.azureedge.net/dist/ABCD/assets/images/user-input.svg"
                              alt="img"
                              loading="lazy"
                            />
                          </div>
                          <input
                            id="name"
                            type="text"
                            name="name"
                            value={name}
                            onChange={handleNameChange}
                            required
                            placeholder={props.t('EnterName')}
                          />
                          {}
                        </div>
                      </div>
                      {/* mf product start */}
                      {props?.params?.IsMFProduct && activeOption === 'SIP' && (
                        <div className="input-field fieldset name-field">
                          <div className="input-inner">
                            <div className="inpt-icon">
                              <img
                                className="input-img"
                                src="https://abconeprod.azureedge.net/dist/ABCD/assets/images/icon-rupee.svg"
                                alt=""
                              />
                            </div>
                            <input
                              id="amount"
                              type="text"
                              name="investedAmount"
                              value={investmentAmount}
                              onChange={(e) => {
                                let inputValue = e.target.value.replace(/\D/g, '');
                                let adjustedValue = Math.min(
                                  inputValue,
                                  props?.fields?.MaxInvestAmount?.value
                                );
                                setInvestmentAmount(adjustedValue);
                                formik.setFieldValue('investmentAmount', adjustedValue);
                                updateVerificationStatus();
                              }}
                              onBlur={formik.handleBlur}
                              required
                              placeholder="Investment Amount"
                            />
                            {formik.errors.investedAmount && formik.touched.investedAmount && (
                              <div className="error-message">{formik.errors.investedAmount}</div>
                            )}
                            {/* <span id="nameError" style="color: red;"></span> */}
                          </div>
                        </div>
                      )}

                      {props?.params?.IsMFProduct && activeOption === 'Lump-sum' && (
                        <div className="input-field fieldset name-field">
                          <div className="input-inner">
                            <div className="inpt-icon">
                              <img
                                className="input-img"
                                src="https://abconeprod.azureedge.net/dist/ABCD/assets/images/icon-rupee.svg"
                                alt=""
                              />
                            </div>
                            <input
                              id="amount"
                              type="text"
                              name="targetedReturnValue"
                              value={investmentAmount}
                              // onChange={handleAmountChange}
                              onChange={(e) => {
                                let inputValue = e.target.value.replace(/\D/g, '');
                                let adjustedValue = Math.min(
                                  inputValue,
                                  props?.fields?.MaxTargetedReturnValue?.value
                                );
                                setInvestmentAmount(adjustedValue);
                                formik.setFieldValue('targetedReturnValue', adjustedValue);
                                updateVerificationStatus();
                              }}
                              onBlur={formik.handleBlur}
                              required
                              placeholder="Targeted Return Value"
                            />
                            {formik.errors.targetedReturnValue &&
                              formik.touched.targetedReturnValue && (
                                <div className="error-message">
                                  {formik.errors.targetedReturnValue}
                                </div>
                              )}
                            {/* <span id="nameError" style="color: red;"></span> */}
                          </div>
                        </div>
                      )}

                      {props?.params?.IsMFProduct && (
                        <div className="input-field fieldset name-field">
                          <div className="input-inner">
                            <div className="calculator_range_slider_grid">
                              <div className="calc_rslider_content">
                                <span className="rsLabel">PERIOD</span>
                              </div>
                              <div className="slider-container calc_period">
                                {combinedData.map((item) => (
                                  <label key={item.key}>
                                    <input
                                      type="radio"
                                      name="radio"
                                      checked={selectedPeriod.key === item.key}
                                      onChange={() => handleCalculatorPeriodChange(item.key)}
                                    />
                                    <span>{item.label}</span>
                                  </label>
                                ))}
                              </div>
                            </div>
                          </div>
                        </div>
                      )}

                      {/* mf product start */}

                      {/* digigold section start */}
                      {props?.params?.IsDigiGold === '1' && (
                        <>
                          <div className="buy_in_rupees">
                            <div className="input-field fieldset name-field">
                              <div className="input-inner">
                                <div className="inpt-icon">
                                  {selectedRadio === 'BuyInRupee' ? (
                                    <img
                                      className="input-img"
                                      src="https://abconeprod.azureedge.net/dist/ABCD/assets/images/rupees_icon.svg"
                                      alt=""
                                    />
                                  ) : (
                                    <img
                                      className="input-img"
                                      src="https://abconeprod.azureedge.net/dist/ABCD/assets/images/grams_icon.svg"
                                      alt=""
                                    />
                                  )}
                                </div>
                                <input
                                  id="banner_rupees"
                                  type="number"
                                  name="rupees"
                                  required=""
                                  placeholder={
                                    selectedRadio === 'BuyInRupee'
                                      ? props?.t('EnterAmount')
                                      : props?.t('EnterGram')
                                  }
                                  min={0}
                                  max={9999999}
                                  step="0.01"
                                  value={amount}
                                  onChange={handleAmountChange}
                                />
                                {/* <span id="nameError" style="color: red;"></span> */}
                                <div className="conversion_results" id="banner_form_rupee_results">
                                  {selectedRadio === 'BuyInRupee' ? (
                                    <>
                                      {gramValueReuslt} {props?.t('WEIGHT_GM')}
                                    </>
                                  ) : (
                                    <>
                                      {props?.t('CURRENCY_ICON')} {rupeeValueResult}
                                    </>
                                  )}
                                </div>
                              </div>
                            </div>
                            <div className="digi_gold_amnt_wrapper digi_gold_amnt_wrapper_style">
                              <ul>
                                {radioButtons
                                  .find((radio) => radio.name === selectedRadio)
                                  ?.fields.Contents.map((item) => (
                                    <li
                                      key={item.id}
                                      className={item.fields.IsPopular.value && 'popular_tag'}
                                    >
                                      <a
                                        className={`${
                                          selectedCheckbox === item.fields.Title.value
                                            ? 'selected'
                                            : ''
                                        }`}
                                        href="javascript:void(0);"
                                        onClick={() =>
                                          handleCheckboxChange(item.fields.Title.value)
                                        }
                                      >
                                        {item.fields.IsPopular.value && (
                                          <span className="pop_price">
                                            {props?.t('IsPopular_2')}
                                          </span>
                                        )}
                                        {selectedRadio === 'BuyInRupee' &&
                                          props?.t('CURRENCY_ICON')}{' '}
                                        {item.fields.Title.value} {}{' '}
                                        {selectedRadio === 'BuyInGrams' && props?.t('WEIGHT_GM')}{' '}
                                        <img
                                          className="selected_amnt"
                                          src="https://abconeprod.azureedge.net/dist/ABCD/assets/images/amnt_select.svg"
                                        />
                                      </a>
                                    </li>
                                  ))}
                              </ul>
                            </div>
                          </div>
                        </>
                      )}

                      {/* digigold section end */}

                      <div className="input-field fieldset number-field">
                        <div className="input-inner country_code_91">
                          <div className="inpt-icon">
                            <img
                              className="input-img"
                              src="https://abconeprod.azureedge.net/dist/ABCD/assets/images/input-phone.svg"
                              alt="img"
                              loading="lazy"
                            />
                          </div>

                          <input
                            type="tel"
                            placeholder={props.t('EnterPhone')}
                            name="mobileNumber"
                            value={mobileNumber}
                            onChange={handleMobileNumberChange}
                            onKeyPress={handleKeyPress}
                            maxLength="10"
                            required
                          />
                        </div>
                        {phoneErrorVisible && (
                          <span id="phoneError" style={{ color: 'red' }}>
                            {}
                            {props?.i18n?.store?.data?.en?.translation?.InvalidPhone}
                          </span>
                        )}
                      </div>

                      {props?.params?.IsMFProduct && (
                        <div className="yellowBox">
                          <p>
                            {props.t('Total_investment')}{' '}
                            <strong>
                              {props?.t('CURRENCY_ICON')}{' '}
                              {totalInvested ? totalInvested : requiredInvestment}
                            </strong>
                            <br /> {props?.t('Expected_Gain')}{' '}
                            <strong>
                              {props?.t('CURRENCY_ICON')}{' '}
                              {totalGain ? totalGain : expectedWealthGain}
                            </strong>{' '}
                          </p>
                          {/* <p className="value">
                            <strong>
                              {props?.t('CURRENCY_ICON')}{' '}
                              {totalGain ? totalGain : expectedWealthGain}
                            </strong>{' '}
                            ₹2,00,000 (+10.8% XIRR)
                          </p> */}
                        </div>
                      )}

                      {/* gold loan section start */}

                      {props?.params?.IsGoldLoan === '1' && (
                        <>
                          <div className="input-field fieldset number-field">
                            <div className="input-inner ">
                              <div className="inpt-icon">
                                <img
                                  className="input-img"
                                  src="https://abconeprod.azureedge.net/dist/ABCD/assets/images/loan_amnt.svg"
                                  alt=""
                                />
                              </div>
                              <input
                                type="number"
                                id="loan_amount"
                                name="loan_amnt"
                                required=""
                                placeholder={props?.t('Loan_Amount')}
                                value={loanAmount}
                                onChange={handleloanAmountChange}
                              />
                            </div>
                          </div>
                          <div className="input-field fieldset number-field">
                            <div className="input-inner ">
                              <div className="inpt-icon">
                                <img
                                  className="input-img"
                                  src="https://abconeprod.azureedge.net/dist/ABCD/assets/images/pincode.svg"
                                  alt=""
                                />
                              </div>
                              <input
                                type="text"
                                id="pincode"
                                name="pincode"
                                maxLength={6}
                                placeholder={props?.t('PinCode')}
                                value={pincode}
                                onChange={handlePincodeChange}
                              />
                            </div>
                          </div>
                          <div className="input-field fieldset name-field">
                            <div className="input-inner">
                              <div className="calculator_range_slider_grid">
                                {props?.fields?.LoanTypes.map((loantype, ind) => (
                                  <>
                                    <div className="calc_rslider_content" key={ind}>
                                      <span className="rsLabel">
                                        {loantype?.fields?.heading?.value}
                                      </span>
                                    </div>

                                    <div className="slider-container calc_period">
                                      {loantype?.fields?.Contents.map((loan, ind) => (
                                        <label key={loan?.fields?.id}>
                                          <input
                                            type="radio"
                                            name="radio"
                                            checked={activeLoanType === loan?.fields?.Title?.value}
                                            onClick={() => {
                                              setActiveLoanType(loan?.fields?.Title?.value);
                                            }}
                                          />
                                          <span>{loan?.fields?.Title?.value}</span>
                                        </label>
                                      ))}
                                    </div>
                                  </>
                                ))}
                              </div>
                            </div>
                          </div>
                        </>
                      )}
                      {/* gold loan section end */}
                      <div className="input-field fieldset checkbox-field">
                        <div className="input-inner">
                          <div className="tacbox">
                            <input
                              id="wp-comment-cookies-consent "
                              name="wp-comment-cookies-consent"
                              required
                              type="checkbox"
                              checked={agreed}
                              onChange={(e) => setAgreed(e.target.checked)}
                            />

                            <label
                              htmlFor="wp-comment-cookies-consent-label"
                              label={props.t('AgreeText')}
                            >
                              {props.t('AgreeText')}
                              {}
                              <Link field={props.rendering?.fields?.TermsnCondition}>
                                {props.t('TermnCondition')}
                              </Link>
                            </label>
                          </div>
                        </div>
                      </div>
                      <div className="btn-field">
                        <button
                          className={`form__btn send-otp ${isVerified ? 'verified' : ''}`}
                          id="btn-1"
                          type="submit"
                          disabled={!isVerified}
                          value="submit"
                          onClick={handleOnSubmit}
                        >
                          {props?.fields?.GetOtpButton?.value
                            ? props?.fields?.GetOtpButton?.value
                            : props.t('OTPButton')}
                        </button>
                      </div>
                      {props?.params?.IsDigiGold === '1' && (
                        <p className="disclaimer_gold">{props?.fields?.Disclaimer?.value}</p>
                      )}
                    </div>
                  </form>
                )}

                {}
                {currentStep === 2 && (
                  <form
                    className={`form ${formClasses.form2}`}
                    id="stepper-form-1-step-2"
                    onSubmit={validateAndSubmit}
                  >
                    <div className="otp-vcarification-step height-100 d-flex justify-content-center align-items-center p-top-space">
                      <div className="position-relative">
                        <div className="card p-2 text-center">
                          <h3 className="otp-varification-heading">{props.t('OTPVerification')}</h3>
                          <p className="otp-para">{props.t('OTPVerificationMessage')}</p>
                          <p className="otp-number ">
                            {props.t('CountryCode')} {mobileNumber}
                            <span
                              className="change-number"
                              onClick={changeNumber}
                              style={{ cursor: 'pointer' }}
                            >
                              {props.t('ChangeNumber')}
                            </span>
                          </p>
                          <p className="resend-otp">
                            <CountdownTimer
                              ref={countdownTimerRef}
                              resendCode={resendCode}
                              buttonText={buttonText}
                            />
                          </p>

                          <div
                            id="otp"
                            className="inputs d-flex flex-row justify-content-center mt-2"
                            onPaste={handlePaste}
                          >
                            {Array.from({ length: 6 }, (_, index) => (
                              <input
                                key={index}
                                ref={(el) => (inputs.current[index] = el)}
                                required
                                className="m-2 text-center form-control rounded"
                                type="text"
                                maxLength="1"
                                value={otpValue[index]}
                                onChange={(e) => handleChange(index, e.target.value)}
                                onKeyDown={(e) => handleKeyDown(index, e)}
                              />
                            ))}
                          </div>
                          {responseCode === '0' && (
                            <span id="phoneError" style={{ color: 'red' }}>
                              {props.t('OTPServiceError')}
                            </span>
                          )}
                          {responseCode === '-1' && (
                            <span id="phoneError" style={{ color: 'red' }}>
                              {props.t('InvalidOTP')}
                            </span>
                          )}
                          {responseCode === '400' && (
                            <span id="phoneError" style={{ color: 'red' }}>
                              {props.t('LMServiceError')}
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                    <button
                      className={`form__btn verify-btn ${isOtpFilled() ? 'verified' : ''}`}
                      id="btn-2-next"
                      type="submit"
                      value="submit"
                      onClick={(e) =>
                        validateAndSubmit(
                          e,
                          props?.fields?.VerifyOtpButton?.value
                            ? props?.fields?.VerifyOtpButton?.value
                            : props?.t('VerifyOTP')
                        )
                      }
                      disabled={submittingForm}
                    >
                      {submittingForm
                        ? props?.fields?.VerifyingOtpButton?.value
                          ? props?.fields?.VerifyingOtpButton?.value
                          : props.t('Verifying')
                        : props?.fields?.VerifyOtpButton?.value
                        ? props?.fields?.VerifyOtpButton?.value
                        : props?.t('VerifyOTP')}
                    </button>
                  </form>
                )}

                {currentStep === 3 && (
                  <form id="stepper-form-1-step-3" className={`form ${formClasses.form3}`}>
                    <div className="stepper-heaiding-mb thankYou-banner-form">
                      <div className="heading-inner">
                        <div className="verified-icon">
                          <Image field={props.rendering?.fields?.ThankYouIcon} loading="lazy" />
                        </div>
                        <span className="stepper-heading">
                          {props?.rendering?.fields?.ThankYouMessage?.value
                            ? props.rendering?.fields?.ThankYouMessage?.value
                            : props.t('ThankMessage1')}
                        </span>
                        <p className="stepper-paragraph">
                          {props?.rendering?.fields?.ThankYouMessageSub?.value
                            ? props.rendering?.fields?.ThankYouMessageSub?.value
                            : props.t('ThankMessage2')}
                        </p>
                      </div>
                    </div>
                    {redirecting && props.rendering?.fields?.RedirectURL?.value?.url && (
                      <div className="redirect-message mt-3">
                        {countdown !== 0 && (
                          <p className="stepper-paragraph">
                            {props?.t('Redirecting')} {countdown} {props?.t('Seconds')}
                          </p>
                        )}
                        {/* <div className="accr-buttons-new-ui">
                            <a className="know_more_about-us border_solid" onClick={handleStay}>
                              {props?.t('Stay')}
                            </a>
                          </div> */}
                      </div>
                    )}
                    {props.rendering?.fields?.ThankYouCTA?.value?.text && (
                      <Link
                        className="form__btn form__btn_3 verify-btn verified"
                        id="btn-3"
                        field={props.rendering?.fields?.ThankYouCTA}
                      >
                        {props?.t('ExploreProducts')}
                      </Link>
                    )}
                  </form>
                )}
              </div>
              <div className="form--message"></div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default withTranslation()(ABCDLeadForm);
